<template>
  <div class="info-page-container">
    <div class="logo-container"></div>
    <div class="inner cl" style="width: 13rem;overflow:hidden;">
      <div style="position: absolute;top: 50%;transform: translateY(-50%);">
          <img class="fl" src="../../../assets/images/product-feature@2x.png" style="width:8.4rem;height:5.44rem;margin-top: 0.36rem;"/>
          <div class="info-main-container fl" style="width: 4.6rem;">
            <div class="fund-string"></div>
            <slot name="info"></slot>
          </div>
      </div>
      <div class="contact-info">
        <p style="padding-bottom:0.5em;">
            <span>联系我们：</span>
            <span style="margin-left:1em;">181-2206-2906 黎经理</span>
            <span style="margin-left:1em;">邮箱：data@simuwang.com</span>
        </p>
        <p>
            <span>版权所有&copy;深圳市排排网投资管理股份有限公司</span>
            <span style="margin-left:1em;">ICP证粤B2-20110208</span>
            <span style="margin-left:1em;">粤ICP备09068203号</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import pageView from "../../../common/mixins/pageView";
export default {
  mixins: [pageView],
  data() {
    return {
    };
  },
  mounted() {
    this.setRem();
    window.addEventListener("resize", this.resizeSetRem);
  },
  methods: {
    // 设置页面响应式的rem
    setRem() {
      $("html").css({
        "font-size": ($(document.body).width() * 10) / 192 + "px"
      });
    },
    resizeSetRem() {
      if ($(document.body).width() < 1300) {
        return;
      }
      this.setRem();
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeSetRem);
  }
};
</script>
<style lang="less" scoped>
html,
body {
  font-family: "微软雅黑", "Microsoft Yahei";
  height: 100%;
  margin: 0;
  padding: 0;
}
.info-page-container {
  width: 100%;
  height: 100%;
  background: url("../../../assets/images/login_bg.jpg") no-repeat center center;
  background-size: 100% 100%;
  // logo
  .logo-container {
    width: 1.62rem;
    height: 0.61rem;
    margin: 0.4rem 0 0 0.4rem;
    position: absolute;
    background: url("../../../assets/images/logo.png") no-repeat center center;
    background-size: 100% 100%;
  }
  // 版心
  .inner {
    height: 100%;
    margin: 0 auto;
    position: relative;
    .info-main-container{
        .fund-string{
            width: 2.6rem;
            height: .86rem;
            margin: 0 auto;
            background: url('../../../assets/images/master-logo@2x.png') no-repeat center center;
            background-size: 100% 100%;
        }
    }
    // 底部信息
    .contact-info {
        font-size:0.16rem;
        font-weight:400;
        color:#8D9095;
        text-align: center;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0.4rem;
        width: 100%;
    }
  }
}
</style>
